export const formatPriceToFinancial = (totalPrice: string) => {
	const value = +parseFloat(totalPrice).toFixed(2);
	return value.toLocaleString('en-AU', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	});
}